import { sumField } from "./listExportUtils";

const money = (n) => (Number(n) || 0).toFixed(2);

// Grand-totals row for the on-screen DataTable (antd's own `summary`
// render-prop, forwarded through by DataTable.jsx's `summary` prop).
// `sumFields` is the antd column `dataIndex` list to sum; `labelDataIndex`
// is which column shows the word "Total". Returns a function suitable to
// pass directly as `<DataTable summary={...} />`.
export const makeGrandTotalSummary = (columns, rows, sumFields, labelDataIndex) => () => (
  <tr className="ant-table-row" style={{ fontWeight: 600, background: "#fafafa" }}>
    {columns.map((col, i) => {
      const key = col.dataIndex || col.key || i;
      if (key === labelDataIndex) {
        return <td key={key} className="ant-table-cell">Total</td>;
      }
      if (sumFields.includes(key)) {
        return <td key={key} className="ant-table-cell">{money(sumField(rows, key))}</td>;
      }
      return <td key={key} className="ant-table-cell" />;
    })}
  </tr>
);
